import axios from "axios";
import * as Sentry from "@sentry/react";
import { apiSettings } from "./master.setting";

export const getCourseTask = async ({ taskId }, headers) => {
    const result = await axios
        .get(`v2/portal/CourseTasks/${taskId}`, {
            headers,
        })
        .then((res) => res)
        .catch((error) => {
            if (error.response) {
                const statusCode = error.response.status;
                if (statusCode !== 400 && statusCode !== 401) {
                    Sentry.captureException(error);
                }
            }
            return error?.response;
        });
    return result;
};

export const validateCourseTask = async ({ validate, taskId, isSubmit, headers }) => {

  const backendValidation = {
    backendValidationSettings: apiSettings,
    ...validate,
  };
  
  const result = await axios.post(
    `/v2/portal/CourseTasks/${taskId}/validate/${isSubmit}`,
    backendValidation,
    {
      headers,
    }
  );
  return result.data;
};

export const getBookJson = async ({ url }, headers) => {
    const result = await axios
        .get(url, {
            headers,
        })
        .then((res) => res)
        .catch((error) => {
            if (error.response) {
                const statusCode = error.response.status;
                if (statusCode !== 400 && statusCode !== 401) {
                    Sentry.captureException(error);
                }
            }
            return error?.response;
        });
    return result;
};
